import { toTypedRxJsonSchema } from 'rxdb';
import type { ExtractDocumentTypeFromTypedRxJsonSchema, RxJsonSchema } from 'rxdb';

export const branchSchemaLiteral = {
  title: 'branch',
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: { type: 'string', maxLength: 100 },
    name: { type: 'string', maxLength: 100 },
    code: { type: 'string', maxLength: 10 },
    is_active: { type: 'boolean' },
    created_at: { type: 'string', maxLength: 50 },
    updated_at: { type: 'string', maxLength: 50 },
    is_deleted: { type: 'boolean' },
    
    last_modified_by: { type: ['string', 'null'], maxLength: 100 },
  },
  required: ['id', 'name', 'updated_at', 'is_deleted', 'is_active'],
  indexes: ['is_deleted', 'updated_at'],
} as const;

const schemaTyped = toTypedRxJsonSchema(branchSchemaLiteral);
export type BranchDocType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;
export const branchSchema: RxJsonSchema<BranchDocType> = branchSchemaLiteral;
